<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "table-instruktur",
  props: ["idPembelajaran", "durasiPembelajaran"],
  components: [],
  data() {
    return {
      app_url: process.env.VUE_APP_URL,
      peserta_ref: [],
      instruktur_pembelajaran: "",
      loadingTable: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    fullDateTimeFormat(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    hitungJamMengajar(jam_mengajar) {
      return jam_mengajar * parseInt(this.durasiPembelajaran);
    },
    getData() {
      this.loadingTable = true;

      const conf = {
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/instruktur",
        method: "get",
        params: { idPembelajaran: this.idPembelajaran },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(conf).then((res) => {
        var resFix = res.data.data;
        this.instruktur_pembelajaran = resFix[0];
        this.loadingTable = false;
      });
    },
    changeStatusData(status, id) {
      let self = this;

      let text_alert = "";
      if (status == "1") {
        text_alert = "Apakah anda yakin ingin mengirim undangan?";
      }

      Swal.fire({
        title: "Perhatian",
        text: text_alert,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          self.loadingTable = true;
          Swal.fire({
            title: '<i class="fa fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
          });

          var config = {
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "transactions/pra-pelaksanaan/instruktur",
            data: {
              id: id,
              status: status,
              user_id: localStorage.getItem("session_user_id"),
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          };
          axios(config).then((response) => {
            var response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              if (response_data.data.status == true) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: "Data berhasil diperbarui.",
                  timer: 2000,
                  timerProgressBar: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                }).then((result) => {
                  /* Read more about handling dismissals below */
                  if (result.dismiss === Swal.DismissReason.timer) {
                    self.$emit("refresh-table", []);
                  }
                });
              } else if (response_data.data.status == "nothing") {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Mohon isi link Grup WA, kelas dan unggah surat undangan instruktur.",
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Data Instruktur tidak ditemukan.",
                });
              }
            }
          });
        } else {
          Swal.close();
        }
      });
    },
    deleteData(id) {
      let self = this;
      Swal.fire({
        title: "Perhatian",
        text: "Anda yakin ingin menghapus data tersebut?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          self.loadingTable = true;
          Swal.fire({
            title: '<i class="fa fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
          });

          var config = {
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "transactions/pra-pelaksanaan/instruktur",
            data: {
              id: id,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          };
          axios(config).then((response) => {
            var response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  self.$emit("refresh-table", []);
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
    kirimLinkFormNilai(idPembelajaran, idInstruktur) {
      Swal.fire({
        title: '<i class="fa fa-spinner fa-spin"></i>',
        text: "Loading Kirim Link Form Nilai...",
        showConfirmButton: false,
      });

      var config_kirim_undangan = {
        method: "post",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/link-form-nilai",
        data: {
          id_pembelajaran: idPembelajaran,
          id_instruktur: idInstruktur,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_kirim_undangan).then((response) => {
        console.log(response);
        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: `Berhasil Kirim Link Form Nilai ke Nomor Whatsapp Instruktur.`,
          timer: 2000,
          timerProgressBar: true,
          showCancelButton: false,
          showConfirmButton: false,
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            Swal.close();
          }
        });
      });
    },
    unduhExcelNilai(id_pembelajaran, id_instruktur) {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading Ekspor Data ...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config = {
        method: "get",
        responseType: "arraybuffer",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/instruktur/export-nilai",
        params: {
          id_pembelajaran: id_pembelajaran,
          id_instruktur: id_instruktur,
        },
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          Accept: "application/vnd.ms-excel",
        },
      };

      axios(config).then(function (response) {
        if (response.data.meta?.code == 500) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "Error, mohon coba lagi.",
          });
        } else {
          Swal.close();
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/csv" })
          );
          // console.log(url);
          const link = document.createElement("a");
          link.href = url;
          const timestamp = moment().format("YYYYMMDD_HHmmss");
          link.setAttribute(
            "download",
            "export-nilai-instruktur-" + timestamp + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        }
      });
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <div class="table-responsive">
    <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
      <thead class="bg-dark text-center text-white">
        <tr>
          <th style="width: 25px; vertical-align: middle">No</th>
          <th style="width: 250px; vertical-align: middle">Nama</th>
          <th style="width: 120px; vertical-align: middle">NIP</th>
          <th style="width: 125px; vertical-align: middle">Golongan</th>
          <th style="width: 125px; vertical-align: middle">Pangkat</th>
          <th style="width: 125px; vertical-align: middle">Pendidikan Terakhir</th>
          <th style="width: 125px; vertical-align: middle">No WhatsApp</th>
          <th style="width: 125px; vertical-align: middle">Jabatan</th>
          <th style="width: 125px; vertical-align: middle">Instansi</th>
          <th style="width: 125px; vertical-align: middle">Alamat Instansi</th>
          <!-- <th style="width: 125px; vertical-align: middle">Asal</th> -->
          <!-- <th style="width: 125px; vertical-align: middle; vertical-align: middle">
            Realisasi Jam Mengajar
          </th> -->
          <!-- <th style="width: 125px; vertical-align: middle">Status</th> -->
          <th style="width: 35px; max-width: 75px; vertical-align: middle">Aksi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loadingTable == true">
          <td class="text-center" colspan="30">
            <i class="fas fa-spinner fa-spin"></i> Loading...
          </td>
        </tr>
        <tr v-else-if="instruktur_pembelajaran == ''">
          <td class="text-center" colspan="30">Data Tidak Tersedia</td>
        </tr>
        <tr v-else v-for="(row_data, key_data) in instruktur_pembelajaran" :key="key_data">
          <td class="text-center">
            {{ parseInt(key_data) + 1 }}.
          </td>
          <td>{{ row_data.user.name }}</td>
          <td class="text-center">
            {{ row_data.user.username }}
          </td>
          <td class="text-center">{{ row_data.user.golongan }}</td>
          <td class="text-center">{{ row_data.user.pangkat }}</td>
          <td class="text-center">{{ row_data.user.pendidikan_terakhir }}</td>
          <td class="text-center">{{ row_data.user.mobile_phone }}</td>
          <td class="text-center">{{ row_data.user.jabatan_name }}</td>
          <td class="text-center">{{ row_data.user.instansi }}</td>
          <td class="text-center">{{ row_data.user.alamat_instansi }}</td>
          <td class="text-center">
            <div v-if="row_data.status_instruktur == '0'">
              <!-- <div class="d-grid gap-2">
                <button type="button" class="btn btn-success btn-sm btn-block" @click="changeStatusData(1, row_data.pli_id)">
                  <i class="bx bx-mail-send"></i> Kirim Undangan
                </button>
              </div> -->
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-danger btn-sm btn-block" @click="deleteData(row_data.pli_id)">
                  <i class="bx bx-trash"></i> Hapus
                </button>
              </div>
            </div>
            <div v-else-if="row_data.status_instruktur == '1'">
              <!-- <div class="d-grid gap-2">
                <button type="button" class="btn btn-success btn-sm btn-block" @click="changeStatusData(1, row_data.pli_id)">
                  <i class="bx bx-mail-send"></i> Kirim Undangan
                </button>
              </div> -->
              <div class="d-grid gap-2">
                <a role="button" class="btn btn-info btn-sm btn-block" v-bind:href="app_url +
                  'data-pembelajaran/confirm-kehadiran-instruktur' +
                  '/' +
                  row_data.pli_pbl_id_encrypt +
                  '/' +
                  row_data.pli_id_instruktur_encrypt
                  " target="_blank">
                  <i class="bx bx-link"></i> Link Undangan
                </a>
              </div>
            </div>
            <div v-else-if="row_data.status_instruktur == '2'">
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-success btn-sm btn-block">
                  CONFIRMED ({{ fullDateTimeFormat(row_data.updated_at) }})
                </button>
              </div>
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-info btn-sm btn-block" @click="
                  kirimLinkFormNilai(
                    row_data.pli_pbl_id_encrypt,
                    row_data.pli_id_instruktur_encrypt
                  )
                  ">
                  <i class="bx bx-mail-send"></i> Kirim Link Form Nilai
                </button>
              </div>
              <div class="d-grid gap-2">
                <a role="button" class="btn btn-primary btn-sm btn-block" v-bind:href="app_url +
                  'data-pembelajaran/penilaian-peserta' +
                  '/' +
                  row_data.pli_pbl_id_encrypt +
                  '/' +
                  row_data.pli_id_instruktur_encrypt
                  " target="_blank">
                  <i class="fa fa-edit"></i> Form Nilai
                </a>
              </div>
              <div class="d-grid gap-2">
                <button type="button" class="btn btn-warning btn-sm btn-block" @click="
                  unduhExcelNilai(
                    row_data.pli_pbl_id,
                    row_data.pli_id_instruktur
                  )
                  ">
                  <i class="fa fa-file-excel"></i> Unduh Excel Nilai
                </button>
              </div>
            </div>
            <div v-else-if="row_data.status_instruktur == '3'">
              <div class="badge badge-pill badge-soft-success font-size-11">
                CONFIRMED ({{ fullDateTimeFormat(row_data.updated_at) }})
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
